// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import _store from './store/global'
import LottieAnimation from 'lottie-web-vue'
import LS from 'local-storage'

Vue.config.productionTip = false

Vue.use(Vuex)
const store = new Vuex.Store(_store)

Vue.use(LottieAnimation)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store: store,
  LS: LS,
  template: '<App/>',
  components: { App },
  created () {
    this.$store.commit('initState', '')
  }
})



// WEBPACK FOOTER //
// ./src/main.js